export const Configuration = {
  Base: {
    path: '/configuration',
    name: 'configuration'
  },
  Organisation: {
    Management: {
      path: '/configuration/organisations',
      name: 'organisationManagement'
    },
    Add: {
      path: '/configuration/organisations/add',
      name: 'addOrganisation'
    },
    View: {
      path: '/configuration/organisations/:id',
      name: 'viewOrganisation'
    },
    Edit: {
      path: '/configuration/organisations/edit/:id',
      name: 'editOrganisation'
    }
  },
  User: {
    Management: {
      path: '/configuration/users',
      name: 'userManagement'
    },
    Add: {
      path: '/configuration/users/add',
      name: 'addUser'
    },
    View: {
      path: '/configuration/users/:id',
      name: 'viewUser'
    },
    Edit: {
      path: '/configuration/users/edit/:id',
      name: 'editUser'
    },
    Copy: {
      path: '/configuration/users/add',
      name: 'copyUser'
    }
  },
  Role: {
    Management: {
      path: '/configuration/roles',
      name: 'roleManagement'
    },
    Add: {
      path: '/configuration/roles/add',
      name: 'addRole'
    },
    View: {
      path: '/configuration/roles/:id',
      name: 'viewRole'
    },
    Edit: {
      path: '/configuration/roles/edit/:id',
      name: 'editRole'
    },
    Copy: {
      path: '/configuration/roles/add',
      name: 'copyRole'
    }
  },
  SingleSignOn: {
    Management: {
      path: '/configuration/singlesignon',
      name: 'singleSignOnManagement'
    }
  },
  ExternalAPIKeyManagement: {
    Management: {
      path: '/configuration/externalAPIKeys',
      name: 'externalApiKeyManagement'
    }
  },
  LeaversTool: {
    Base: {
      path: '/configuration/leaverstool',
      name: 'leaversToolConfiguration'
    }
  },
  LeaverRule: {
    Management: {
      path: '/configuration/leaverrules',
      name: 'leaverRules'
    },
    Add: {
      path: '/configuration/leaverrules/add/:configurationId',
      name: 'addLeaverRule'
    },
    Edit: {
      path: '/configuration/leaverrules/edit/:configurationId/:ruleId',
      name: 'editLeaverRule'
    }
  },
  DocuSign: {
    AdditionalDocument: {
      Management: {
        path: '/configuration/docusign/additionaldocuments',
        name: 'docusignAdditionalDocumentManagement'
      },
      Add: {
        path: '/configuration/docusign/additionaldocuments/add',
        name: 'docusignAddAdditionalDocument'
      },
      Edit: {
        path: '/configuration/docusign/additionaldocuments/edit/:id',
        name: 'docusignEditAdditionalDocument'
      }
    },
    AdditionalDocumentSignTab: {
      Management: {
        path: '/configuration/docusign/additionaldocuments/:id/signtabs',
        name: 'docusignAdditionalDocumentSignTabManagement'
      },
      Add: {
        path: '/configuration/docusign/additionaldocuments/:id/signtabs/add',
        name: 'docusignAddAdditionalDocumentSignTab'
      },
      Edit: {
        path: '/configuration/docusign/additionaldocuments/:additionalDocumentId/signtabs/edit/:id',
        name: 'docusignEditAdditionalDocumentSignTab'
      }
    },
    AfterSignMapping: {
      Management: {
        path: '/configuration/docusign/aftersignmappings',
        name: 'docusignAfterSignMappingsManagement'
      },
      Edit: {
        path: '/configuration/docusign/aftersignmappings/edit/:id',
        name: 'docusignEditTemplateAfterSignMappings'
      }
    },
    SignerRole: {
      Management: {
        path: '/configuration/docusign/signerroles',
        name: 'docusignSignerRoleManagement'
      },
      Add: {
        path: '/configuration/docusign/:documentTypeId/signerroles/add',
        name: 'docusignAddSignerRole'
      },
      Edit: {
        path: '/configuration/docusign/:documentTypeId/signerroles/edit/:id',
        name: 'docusignEditSignerRole'
      }
    },
    Settings: {
      Base: {
        path: '/configuration/docusign/settings',
        name: 'docusignSettings'
      }
    },
    Template: {
      Management: {
        path: '/configuration/docusign/templates',
        name: 'docusignTemplateManagement'
      },
      Edit: {
        path: '/configuration/docusign/:documentTypeId/templates/edit/:id',
        name: 'docusignEditTemplate'
      },
      Add: {
        path: '/configuration/docusign/:documentTypeId/templates/add',
        name: 'docusignAddTemplate'
      }
    },
    TemplateSignHere: {
      Management: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/signheres',
        name: 'docuSignTemplateSignHereManagement'
      },
      Edit: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/signheres/edit/:id',
        name: 'docusignEditTemplateSignHere'
      },
      Add: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/signheres/add',
        name: 'docusignAddTemplateSignHere'
      }
    },
    TemplateAdditionalDocument: {
      Management: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/additionaldocuments',
        name: 'docuSignTemplateAdditionalDocumentManagement'
      },
      Edit: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/additionalDocuments/edit/:id',
        name: 'docusignEditTemplateAdditionalDocument'
      },
      Add: {
        path: '/configuration/docusign/:documentTypeId/templates/:templateId/additionalDocuments/add',
        name: 'docusignAddTemplateAdditionalDocument'
      }
    },
    DocumentType: {
      Management: {
        path: '/configuration/docusign/documenttypes',
        name: 'docusignEditDocumentTypes'
      }
    },
    AccountMangement: {
      Base: {
        path: '/configuration/docusign/accountconfiguration',
        name: 'docusignAccountConfiguration'
      }
    }
  },
  Scrive: {
    DocumentType: {
      Management: {
        path: '/configuration/scrive/documenttypes',
        name: 'scriveEditDocumentTypes'
      }
    },
    SignerRole: {
      Management: {
        path: '/configuration/scrive/signerroles',
        name: 'scriveSignerRoleManagement'
      },
      Add: {
        path: '/configuration/scrive/:documentTypeId/signerroles/add',
        name: 'scriveAddSignerRole'
      },
      Edit: {
        path: '/configuration/scrive/:documentTypeId/signerroles/edit/:id',
        name: 'scriveEditSignerRole'
      }
    },
    Template: {
      Management: {
        path: '/configuration/scrive/templates',
        name: 'scriveTemplateManagement'
      },
      Edit: {
        path: '/configuration/scrive/:documentTypeId/templates/edit/:id',
        name: 'scriveEditTemplate'
      },
      Add: {
        path: '/configuration/scrive/:documentTypeId/templates/add',
        name: 'scriveAddTemplate'
      }
    },
    SigningParty: {
      Edit: {
        path: '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/edit/:id',
        name: 'scriveEditSigningParty'
      },
      Add: {
        path: '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/add',
        name: 'scriveAddSigningParty'
      }
    },
    SigningPartyField: {
      Edit: {
        path: '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/:signingPartyId/edit/:id',
        name: 'scriveEditSigningPartyField'
      },
      Add: {
        path: '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/:signingPartyId/add',
        name: 'scriveAddSigningPartyField'
      }
    },
    SigningPartyFieldPlacement: {
      Edit: {
        path:
          // tslint:disable-next-line:max-line-length
          '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/:signingPartyId/signingPartyField/:signingPartyFieldId/edit/:id',
        name: 'scriveEditSigningPartyFieldPlacement'
      },
      Add: {
        path:
          // tslint:disable-next-line:max-line-length
          '/configuration/scrive/:documentTypeId/templates/:templateId/signingparties/:signingPartyId/signingPartyField/:signingPartyFieldId/add',
        name: 'scriveAddSigningPartyFieldPlacement'
      }
    },
    AccountMangement: {
      Base: {
        path: '/configuration/scrive/accountconfiguration',
        name: 'scriveAccountConfiguration'
      }
    },
    Settings: {
      Base: {
        path: '/configuration/scrive/settings',
        name: 'scriveSettings'
      }
    },
    AfterSignMapping: {
      Management: {
        path: '/configuration/scrive/aftersignmappings',
        name: 'scriveAfterSignMappingsManagement'
      },
      Edit: {
        path: '/configuration/scrive/aftersignmappings/edit/:id',
        name: 'scriveEditTemplateAfterSignMappings'
      }
    }
  },
  Cabinet: {
    CabinetsDashboard: {
      path: '/configuration/cabinets/dashboard',
      name: 'cabinetsDashboard'
    },
    CabinetDashboard: {
      path: '/configuration/cabinet/:cabinetId/dashboard',
      name: 'cabinetDashboard'
    },
    DocumentTypeDashboard: {
      path: '/configuration/cabinet/:cabinetId/documenttype/:documentTypeId/dashboard',
      name: 'documentTypeDashboard'
    },
    AddCabinet: {
      path: '/configuration/cabinet/add',
      name: 'addCabinet'
    },
    EditCabinet: {
      path: '/configuration/cabinet/:cabinetId/edit',
      name: 'editCabinet'
    },
    AddDocumentType: {
      path: '/configuration/cabinet/:cabinetId/documenttype/add',
      name: 'addDocumentType'
    },
    EditDocumentType: {
      path: '/configuration/cabinet/:cabinetId/documenttype/:documentTypeId/edit',
      name: 'editDocumentType'
    },
    DeleteCabinet: {
      path: '/configuration/cabinet/:cabinetId/delete',
      name: 'deleteCabinet'
    },
    DeleteDocumentType: {
      path: '/configuration/cabinet/:cabinetId/documenttype/:documentTypeId/delete',
      name: 'deleteDocumentType'
    },
    ConfigureRelatedDocumentLinks: {
      path: '/configuration/cabinet/:cabinetId/relatedDocumentsLinks/edit',
      name: 'configureRelatedDocumentLinks'
    },
    GlobalCabinetSecurityConfiguration: {
      path: '/configuration/cabinets/security',
      name: 'globalCabinetSecurityConfiguration'
    },
    CabinetSecurityConfiguration: {
      path: '/configuration/cabinet/:cabinetId/security',
      name: 'cabinetSecurityConfiguration'
    },
    DocumentTypeSecurityConfiguration: {
      path: '/configuration/cabinet/:cabinetId/documenttype/:documentTypeId/security',
      name: 'documetTypeSecurityConfiguration'
    }
  },
  TaskServices: {
    TaskServices: {
      path: '/configuration/taskServices',
      name: 'taskServices'
    },
    TaskServicesGlobalConfiguration: {
      path: '/configuration/taskServices/globalConfiguration',
      name: 'taskServicesGlobalConfiguration'
    },
    TaskServiceConfiguration: {
      path: '/configuration/taskService/:serviceName',
      name: 'taskServiceConfiguration'
    }
  },
  DocumentEncryption: {
    DocumentEncryptionConfiguration: {
      path: '/configuration/documentEncryption',
      name: 'documentEncryptionConfiguration'
    }
  },
  ListMaintenance: {
    ListMaintenance: {
      path: '/configuration/listMaintenance',
      name: 'listMaintenance'
    },
    MaintainBuiltInListItems: {
      path: '/configuration/builtInListItems/:listId',
      name: 'maintainBuiltInListItems'
    }
  },
  ExceptionalJobs: {
    ExceptionalJobsConfiguration: {
      path: '/configuration/exceptionalJobs',
      name: 'exceptionalJobs'
    }
  },
  XPorter: {
    path: '/configuration/xPorter',
    name: 'xPorter'
  }
};
